<section class="modal">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>location_on</mat-icon>
      Add Location | {{ listingTitle }}
    </h1>
  </section>
  <section class="description" mat-dialog-actions>
    <h3>Click on an existing location, or add a new location.</h3>
    <button
      (click)="addNewLocation()"
      mat-button
      title="Add new location."
      type="button"
      >
      <mat-icon>add_box</mat-icon>
      Add Location
    </button>
  </section>
  <section mat-dialog-content>
    <mat-list>
      @for (location of Locations; track location) {
        <mat-list-item
          (click)="selectLocation(location)"
          [ngClass]="{ selected: selectedLocation == location }"
          >
          <section class="location">
            <h3>{{ location.title }}</h3>
          </section>
        </mat-list-item>
      }
    </mat-list>
  </section>
  <section align="end" mat-dialog-actions>
    <button
      (click)="submit()"
      [disabled]="!selectedLocation"
      color="primary"
      mat-raised-button
      matTooltip="Select location."
      >
      Next
      <mat-icon>navigate_next</mat-icon>
    </button>
  </section>
</section>
